module.exports = __webpack_public_path__ + "static/media/main idea.4e385814.mp3";